import { FC, JSX } from "react";
import { useTranslation } from "react-i18next";
import { Fragment } from "react/jsx-runtime";
import styled from "styled-components";

const FollowingErrors = styled("div")({
  marginBottom: "5px",
});

const ErrorsList = styled("ul")({
  paddingLeft: "17px",
});

export interface FormErrorsAlertProps {
  shownErrors: JSX.Element[];
}

const FormErrorsAlert: FC<FormErrorsAlertProps> = ({ shownErrors }) => {
  const { t } = useTranslation();

  return (
    <>
      <FollowingErrors>
        {shownErrors.length > 1
          ? t("common.contentFormErrors")
          : t("common.contentFormError")}
      </FollowingErrors>
      <ErrorsList>
        {shownErrors.map((error, index) => (
          // eslint-disable-next-line react/no-array-index-key
          <Fragment key={index}>{error}</Fragment>
        ))}
      </ErrorsList>
    </>
  );
};

export default FormErrorsAlert;
